import React, { useState } from "react";
import { IconProp } from ".";
import { css } from "@emotion/react";
export default function GripIcon(props: IconProp) {
    const { width = 12, height = 14, color, hoverColor } = props;
    const [isHover, setIsHover] = useState(false);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 14"
            fill="none"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            <path
                d="M3.42857 3.78566C3.42857 3.1937 2.94911 2.71423 2.35714 2.71423H1.07143C0.479464 2.71423 0 3.1937 0 3.78566V5.07138C0 5.66334 0.479464 6.14281 1.07143 6.14281H2.35714C2.94911 6.14281 3.42857 5.66334 3.42857 5.07138V3.78566ZM3.42857 8.92852C3.42857 8.33656 2.94911 7.85709 2.35714 7.85709H1.07143C0.479464 7.85709 0 8.33656 0 8.92852V10.2142C0 10.8062 0.479464 11.2857 1.07143 11.2857H2.35714C2.94911 11.2857 3.42857 10.8062 3.42857 10.2142V8.92852ZM4.28571 3.78566V5.07138C4.28571 5.66334 4.76518 6.14281 5.35714 6.14281H6.64286C7.23482 6.14281 7.71429 5.66334 7.71429 5.07138V3.78566C7.71429 3.1937 7.23482 2.71423 6.64286 2.71423H5.35714C4.76518 2.71423 4.28571 3.1937 4.28571 3.78566ZM7.71429 8.92852C7.71429 8.33656 7.23482 7.85709 6.64286 7.85709H5.35714C4.76518 7.85709 4.28571 8.33656 4.28571 8.92852V10.2142C4.28571 10.8062 4.76518 11.2857 5.35714 11.2857H6.64286C7.23482 11.2857 7.71429 10.8062 7.71429 10.2142V8.92852ZM8.57143 3.78566V5.07138C8.57143 5.66334 9.05089 6.14281 9.64286 6.14281H10.9286C11.5205 6.14281 12 5.66334 12 5.07138V3.78566C12 3.1937 11.5205 2.71423 10.9286 2.71423H9.64286C9.05089 2.71423 8.57143 3.1937 8.57143 3.78566ZM12 8.92852C12 8.33656 11.5205 7.85709 10.9286 7.85709H9.64286C9.05089 7.85709 8.57143 8.33656 8.57143 8.92852V10.2142C8.57143 10.8062 9.05089 11.2857 9.64286 11.2857H10.9286C11.5205 11.2857 12 10.8062 12 10.2142V8.92852Z"
                fill={isHover ? hoverColor : color}
            />
        </svg>
    );
}
